
/* eslint-disable object-shorthand */

import {
    APIResponse,
    User
} from '../../API';

import { getNavigationState as getNavState } from '../../methods';

export const GET_NAVIGATION_STATE_SUCCESS = 'COMMON/NAVIGATION/GET_NAVIGATION_STATE_SUCCESS';
export const GET_USER_INFO_SUCCESS = 'COMMON/NAVIGATION/USER/GET_USER_INFO_SUCCESS';
export const TOGGLE_HELP_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_HELP_DROPDOWN';
export const TOGGLE_MOB_HELP_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_MOB_HELP_DROPDOWN';
export const TOGGLE_VENUE_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_VENUE_DROPDOWN';
export const TOGGLE_MOB_VENUE_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_MOB_VENUE_DROPDOWN';
export const TOGGLE_PERF_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_PERF_DROPDOWN';
export const TOGGLE_MOB_PERF_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_MOB_PERF_DROPDOWN';
export const TOGGLE_INVOICE_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_INVOICE_DROPDOWN';
export const TOGGLE_MOB_INVOICE_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_MOB_INVOICE_DROPDOWN';
export const TOGGLE_INVENT_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_INVENT_DROPDOWN';
export const TOGGLE_MOB_INVENT_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_MOB_INVENT_DROPDOWN';
export const TOGGLE_ADMINHELP_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_ADMINHELP_DROPDOWN';
export const TOGGLE_MOB_ADMINHELP_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_MOB_ADMINHELP_DROPDOWN';
export const TOGGLE_NAV_DROPDOWN = 'COMMON/NAVIGATION/TOGGLE_NAV_DROPDOWN';

export default function (state = {}, action) {
    switch (action.type) {
    case GET_NAVIGATION_STATE_SUCCESS: {
        return getNavigationStateSuccessReducer(state, action);
    }
    case GET_USER_INFO_SUCCESS: {
        return getUserInfoSuccessReducer(state, action);
    }
    case TOGGLE_HELP_DROPDOWN: {
        return toggleHelpDropdownReducer(state);
    }
    case TOGGLE_MOB_HELP_DROPDOWN: {
        return toggleMobHelpDropdownReducer(state);
    }
    case TOGGLE_VENUE_DROPDOWN: {
        return toggleVenueDropdownReducer(state);
    }
    case TOGGLE_MOB_VENUE_DROPDOWN: {
        return toggleMobVenueDropdownReducer(state);
    }
    case TOGGLE_PERF_DROPDOWN: {
        return togglePerfDropdownReducer(state);
    }
    case TOGGLE_MOB_PERF_DROPDOWN: {
        return toggleMobPerfDropdownReducer(state);
    }
    case TOGGLE_INVOICE_DROPDOWN: {
        return toggleInvoiceDropdownReducer(state);
    }
    case TOGGLE_MOB_INVOICE_DROPDOWN: {
        return toggleMobInvoiceDropdownReducer(state);
    }
    case TOGGLE_INVENT_DROPDOWN: {
        return toggleInventDropdownReducer(state);
    }
    case TOGGLE_MOB_INVENT_DROPDOWN: {
        return toggleMobInventDropdownReducer(state);
    }
    case TOGGLE_ADMINHELP_DROPDOWN: {
        return toggleAdminHelpDropdownReducer(state);
    }
    case TOGGLE_MOB_ADMINHELP_DROPDOWN: {
        return toggleMobAdminHelpDropdownReducer(state);
    }
    case TOGGLE_NAV_DROPDOWN: {
        return toggleNavDropdownReducer(state);
    }
    default:
        return state;
    }
}

function getNavigationStateSuccessReducer(state, action) {
    const { navigation } = action.payload;
    return {
        ...state,
        ...navigation
    };
}

function getUserInfoSuccessReducer(state, action) {
    const { user } = action.payload;
    return {
        ...state,
        user: {
            ...state.user,
            ...user,
            adminModeId: 0,
            isLoggedIn: true
        }
    };
}

function toggleHelpDropdownReducer(state) {
    return {
        ...state,
        helpDropdown: {
            ...state.helpDropdown,
            isVisible: !state.helpDropdown.isVisible
        }
    };
}

function toggleMobHelpDropdownReducer(state) {
    return {
        ...state,
        mobHelpDropdown: {
            ...state.mobHelpDropdown,
            isVisible: !state.mobHelpDropdown.isVisible
        }
    };
}

function toggleVenueDropdownReducer(state) {
    return {
        ...state,
        venueDropdown: {
            ...state.venueDropdown,
            isVisible: !state.venueDropdown.isVisible
        }
    };
}

function toggleMobVenueDropdownReducer(state) {
    return {
        ...state,
        mobVenueDropdown: {
            ...state.mobVenueDropdown,
            isVisible: !state.mobVenueDropdown.isVisible
        }
    };
}

function togglePerfDropdownReducer(state) {
    return {
        ...state,
        perfDropdown: {
            ...state.perfDropdown,
            isVisible: !state.perfDropdown.isVisible
        }
    };
}

function toggleMobPerfDropdownReducer(state) {
    return {
        ...state,
        mobPerfDropdown: {
            ...state.mobPerfDropdown,
            isVisible: !state.mobPerfDropdown.isVisible
        }
    };
}

function toggleInvoiceDropdownReducer(state) {
    return {
        ...state,
        invoiceDropdown: {
            ...state.invoiceDropdown,
            isVisible: !state.invoiceDropdown.isVisible
        }
    };
}

function toggleMobInvoiceDropdownReducer(state) {
    return {
        ...state,
        mobInvoiceDropdown: {
            ...state.mobInvoiceDropdown,
            isVisible: !state.mobInvoiceDropdown.isVisible
        }
    };
}

function toggleInventDropdownReducer(state) {
    return {
        ...state,
        inventDropdown: {
            ...state.inventDropdown,
            isVisible: !state.inventDropdown.isVisible
        }
    };
}

function toggleMobInventDropdownReducer(state) {
    return {
        ...state,
        mobInventDropdown: {
            ...state.mobInventDropdown,
            isVisible: !state.mobInventDropdown.isVisible
        }
    };
}

function toggleAdminHelpDropdownReducer(state) {
    return {
        ...state,
        adminHelpDropdown: {
            ...state.adminHelpDropdown,
            isVisible: !state.adminHelpDropdown.isVisible
        }
    };
}

function toggleMobAdminHelpDropdownReducer(state) {
    return {
        ...state,
        mobAdminHelpDropdown: {
            ...state.mobAdminHelpDropdown,
            isVisible: !state.mobAdminHelpDropdown.isVisible
        }
    };
}

function toggleNavDropdownReducer(state) {
    return {
        ...state,
        dropdown: {
            ...state.dropdown,
            isVisible: !state.dropdown.isVisible
        }
    };
}

export const getNavigationState = user => async (dispatch, getState) => {
    try {
        const { config } = getState();
        const res = await getNavState(config, user);
        if (res && res.data) {
            await dispatch(getNavigationStateSuccess(res.data));
            return;
        }
    } catch (error) {
        console.log(error);
    }
};

export const getNavigationStateSuccess = navigation => ({
    type: GET_NAVIGATION_STATE_SUCCESS,
    payload: {
        navigation
    }
});

export const getUserInfo = () => async (dispatch, getState) => {
    try {
        const users = new User({ dispatch, getState });
        const res = await users.authMe();
        if (res && res.data) {
            const response = new APIResponse(res);
            await dispatch(getUserInfoSuccess(response.body));
            await dispatch(getNavigationState(response.body));
            return;
        } else if (res) {
            console.log('Expected status:', 200, 'but received:', res.status);
            console.log('Expected data:', 'user', 'but received:', res.data);
        } else {
            console.log('APIResponse is undefined');
        }
    } catch (error) {
        console.log(error);
    }
};

export const getUserInfoSuccess = user => ({
    type: GET_USER_INFO_SUCCESS,
    payload: {
        user
    }
});

export const toggleHelpDropdown = () => ({
    type: TOGGLE_HELP_DROPDOWN
});

export const toggleMobHelpDropdown = () => ({
    type: TOGGLE_MOB_HELP_DROPDOWN
});

export const toggleVenueDropdown = () => ({
    type: TOGGLE_VENUE_DROPDOWN
});

export const toggleMobVenueDropdown = () => ({
    type: TOGGLE_MOB_VENUE_DROPDOWN
});

export const togglePerfDropdown = () => ({
    type: TOGGLE_PERF_DROPDOWN
});

export const toggleMobPerfDropdown = () => ({
    type: TOGGLE_MOB_PERF_DROPDOWN
});

export const toggleInvoiceDropdown = () => ({
    type: TOGGLE_INVOICE_DROPDOWN
});

export const toggleMobInvoiceDropdown = () => ({
    type: TOGGLE_MOB_INVOICE_DROPDOWN
});

export const toggleInventDropdown = () => ({
    type: TOGGLE_INVENT_DROPDOWN
});

export const toggleMobInventDropdown = () => ({
    type: TOGGLE_MOB_INVENT_DROPDOWN
});

export const toggleAdminHelpDropdown = () => ({
    type: TOGGLE_ADMINHELP_DROPDOWN
});

export const toggleMobAdminHelpDropdown = () => ({
    type: TOGGLE_MOB_ADMINHELP_DROPDOWN
});

export const toggleNavDropdown = () => ({
    type: TOGGLE_NAV_DROPDOWN
});



// WEBPACK FOOTER //
// ./src/modules/navigation/index.js